// src/components/icon/icon.utilities.ts
var iconCache = /* @__PURE__ */ new Map();
async function requestSvgIcon(src) {
  if (iconCache.has(src)) {
    return iconCache.get(src);
  }
  const iconData = await fetch(src);
  const iconFile = {
    ok: iconData.ok,
    status: iconData.status,
    svg: null
  };
  if (iconFile.ok) {
    const div = document.createElement("div");
    div.innerHTML = await iconData.text();
    const svg = div.firstElementChild;
    iconFile.svg = svg?.tagName.toLowerCase() === "svg" ? svg.outerHTML : null;
    iconCache.set(src, iconFile);
  }
  return iconFile;
}

export {
  requestSvgIcon
};
